/**
 * Three icons, because one router serves three products.
 *
 * The public site, the CMS and the PLAYDATA microsite share a root route, so
 * without this they share a favicon and a tab strip cannot tell playbrain.com
 * from the console you are editing it in, or from the microsite. The CMS wears
 * the Playbrain mark with the editing badge — the same badge taiyoro-cms
 * wears, so the two consoles read as a pair. PLAYDATA wears the mark the live
 * playdata.gg serves.
 *
 * Chosen here rather than in a route `head` on purpose: route links
 * CONCATENATE (see buildTagsFromMatches — no dedupe by `rel`), so declaring
 * one on the root and another on a child would ship both and leave the choice
 * to whatever the browser does with a second rel="icon". The document asks
 * once, and exactly one link ships.
 */
export type Favicon = { href: string; type: string }

export const PUBLIC_FAVICON: Favicon = { href: "/favicon.png", type: "image/x-icon" }
export const DASHBOARD_FAVICON: Favicon = {
  href: "/playbrain-cms-favicon.svg",
  type: "image/svg+xml",
}
export const PLAYDATA_FAVICON: Favicon = { href: "/playdata-favicon.png", type: "image/png" }

/** The PLAYDATA microsite lives at /{locale}/playdata and below. */
export function isPlaydataPagePath(pathname: string): boolean {
  const normalizedPathname = pathname.split("?")[0]?.split("#")[0] ?? pathname

  return /^\/[a-z]{2}\/playdata(\/|$)/.test(normalizedPathname)
}

export function faviconFor(pageClass: string, pathname: string): Favicon {
  if (pageClass === "dashboard") return DASHBOARD_FAVICON
  if (isPlaydataPagePath(pathname)) return PLAYDATA_FAVICON
  return PUBLIC_FAVICON
}
